import React from 'react'
import { Avatar, Text, Heading, Icon, IconType, Popover } from '@lmc/ui-kit'
import styled from 'styled-components'
import { Carer } from '@lmc/ts-common'
import { getCarerRole } from '../utils'
import { MailOutlined } from '@ant-design/icons'

type TeamListHeaderProps = {
  carer: Carer
  onClick: React.MouseEventHandler<HTMLDivElement>
  firstItem?: boolean
}

const StyledContainer = styled.div<{ $firstItem?: boolean }>`
  background-color: ${(props) => props.theme.palette.white} !important;
  border-radius: 8px;
  margin-bottom: 10px;
  margin-top: ${(props) => (props?.$firstItem ? '24px' : '0px')};
  height: 64px;
  display: flex;
  align-items: center;
  padding: 16px 12px;
  max-width: 1080px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  cursor: pointer;
  &:hover {
    background-color: ${(props) =>
      props.theme.color.neutral.color10} !important;
  }
  ${({ theme }) => theme.mediaQueries.mobileDown} {
    margin-top: 0px;
  }
`

const StyledWrapper = styled.div`
  display: flex;
  margin-left: auto;
  margin-right: 0px;
  ${({ theme }) => theme.mediaQueries.mobileDown} {
    display: none;
  }
`

const StyledHeading = styled(Heading)`
  margin-left: 10px;
  ${({ theme }) => theme.mediaQueries.mobileDown} {
    margin-right: auto;
  }
`

const StyledText = styled(Text)`
  margin-left: 10px;
  font-size: 12px !important;
  min-width: 130px;
  text-align: center;
`

const StyledPhone = styled(Icon)`
  margin-left: 10px;
  margin-top: 8px;
  color: ${(props) => props.theme.color.neutral.color5} !important;
`
const IconWrapper = styled.div`
  &:hover {
    color: ${(props) => props.theme.color.hover.primary};
  }
  margin-left: 10px;
  margin-top: 6px;
  color: ${(props) => props.theme.color.neutral.color5} !important;
`
const StyledPaddingWrapper = styled.div`
  padding-left: 24px;
  padding-right: 24px;
`

const TeamListItem: React.FC<TeamListHeaderProps> = ({
  carer,
  onClick,
  firstItem,
}) => {
  const picture = carer?.picture as unknown as string
  const name = `${carer?.name?.first} ${carer?.name?.last}`

  return (
    <StyledPaddingWrapper>
      <StyledContainer onClick={onClick} $firstItem={firstItem}>
        <Avatar url={picture} size={40} />
        <StyledHeading level={5}>{name}</StyledHeading>
        {carer?.email && (
          <Popover
            content={
              <Text>
                <a href={`mailto:${carer.email}`}>{carer.email}</a>
              </Text>
            }
          >
            <IconWrapper>
              <MailOutlined style={{ fontSize: '20px' }} />
            </IconWrapper>
          </Popover>
        )}
        {carer?.phoneNumber && (
          <Popover
            content={
              <Text>
                <a href={`tel:${carer.phoneNumber}`}>{carer.phoneNumber}</a>
              </Text>
            }
          >
            <div>
              <StyledPhone customIcon={IconType.Phone} />
            </div>
          </Popover>
        )}
        <StyledWrapper>
          <StyledText level={5}>{getCarerRole(carer?.role)}</StyledText>
        </StyledWrapper>
      </StyledContainer>
    </StyledPaddingWrapper>
  )
}

export default TeamListItem
